import * as Case from 'case';
import { ButtonComponent } from '~contentful/components/button/button.component';
import { ActionModel } from '~contentful/models/actions/action.model';
import { ComponentModel } from '~contentful/models/components/component.model';

export class ButtonModel extends ComponentModel {
  public readonly text: string;
  public readonly style?: any;
  public readonly theme: string;
  public readonly onClick?: ActionModel;
  public readonly componentClass = ButtonComponent;

  public get contextLabel() {
    return this.text;
  }

  public get contextValue() {
    return Case.kebab(this.text) + '-button';
  }
}
